import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  selectIdeaById,
  upvoteIdea,
  downvoteIdea,
  deleteIdea,
} from "store/currentBoardSlice";
import { openModal } from "store/modalsSlice";

import Button from "layout/atoms/Button";
import ContentBox from "layout/atoms/ContentBox";
import Dropdown from "layout/atoms/Dropdown";
import Icon from "layout/atoms/Icon";
import VotesCounter from "layout/molecules/VotesCounter";

import EditMode from "./EditMode";
import Options from "./Options";

import { ReactComponent as EditSvg } from "assets/icons/edit1.svg";
import { ReactComponent as MessageSvg } from "assets/icons/message-square.svg";
import { ReactComponent as TrashSvg } from "assets/icons/trash.svg";
import { Main } from "./styles";

const IdeaCardSmall = ({ ideaId, boardId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("translation", {
    keyPrefix: "boardsDetails.ideaCard",
  });
  const idea = useSelector((state) => selectIdeaById(state, ideaId));
  const [editMode, setEditMode] = useState(false);

  const handleTitleClick = () => {
    dispatch(openModal({ name: "ideaModal", data: { ideaId, boardId } }));
  };

  const handleDelete = () => {
    dispatch(deleteIdea({ ideaId, boardId }));
  };

  if (!idea) return null;

  return (
    <ContentBox
      footer={
        <>
          <VotesCounter
            small
            votesNumber={idea.voteCount}
            isVotedByMe={idea.isVotedByMe}
            onVoteClick={
              idea.isVotedByMe
                ? () => dispatch(downvoteIdea({ ideaId, boardId }))
                : () => dispatch(upvoteIdea({ ideaId, boardId }))
            }
          />
          <Options>
            <Button
              size="sm-square"
              color="white"
              onClick={handleTitleClick}
              disabled={idea.commentCount === 0}
            >
              <Icon src={MessageSvg} />
              <p>{idea.commentCount}</p>
            </Button>
            {idea.canEdit && (
              <Dropdown size="sm-square" closeOnClick>
                <Button
                  size="md"
                  color="white"
                  disabled={editMode}
                  onClick={() => setEditMode(true)}
                >
                  <Icon src={EditSvg} />
                  <p>{t("edit")}</p>
                </Button>
                <Button size="md" color="white" onClick={handleDelete}>
                  <Icon src={TrashSvg} />
                  <p>{t("remove")}</p>
                </Button>
              </Dropdown>
            )}
          </Options>
        </>
      }
    >
      <Main>
        {idea.title && !editMode && (
          <h4 onClick={handleTitleClick}>{idea.title}</h4>
        )}
        {idea.canEdit && editMode && (
          <EditMode
            ideaId={ideaId}
            boardId={boardId}
            title={idea.title}
            description={idea.description}
            status={idea.status}
            canUpdateStatus={idea.canUpdateStatus}
            onCancel={() => setEditMode(false)}
            onSave={() => setEditMode(false)}
          />
        )}
      </Main>
    </ContentBox>
  );
};

IdeaCardSmall.propTypes = {
  ideaId: PropTypes.string,
  boardId: PropTypes.string,
};

export default IdeaCardSmall;
